import React from 'react';
import { useStateValue } from '../../store/store';

const DefaultStep = ({ preview, content, controls, actions }) => {
    const [{ currentIndex, stepsLength }, dispatch] = useStateValue();

    return (
        <div className='step-row'>
            <div className='step-col step-col-left'>

                <div className='step-content'>
                    <img className='ist-logo' src={`${starterTemplates.imageDir}logo.svg`} />
                    {content}

                    {controls && <div className='step-controls'>
                        {controls}
                    </div>}

                </div>

                {actions && <div className='step-actions'>
                    {actions}
                </div>}
            </div>
            <div className='step-col step-col-right'>
                {preview}
            </div>
        </div>
    )
}

export default DefaultStep;
